var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from 'react';
import { UitkCard } from 'uitk-react-cards';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkList, UitkListItem } from 'uitk-react-list';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkHeading, UitkText } from 'uitk-react-text';
import { EGDSPrimaryButton } from '@egds/react-core';
import { ViewLarge, Viewport, ViewSmall } from '@shared-ui/viewport-context';
import { BannerMedia } from './banner-media';
import { useStores } from '../../../utils/hooks';
import { mapMessagingCardMediaProps } from './activity-message-banner-helper';
import { ActivityMessageBannerLink } from './activity-message-banner-link';
export var ActivityMessageBanner = function (_a) {
  var _b;
  var icon = _a.icon,
    mark = _a.mark,
    graphic = _a.graphic,
    action = _a.action,
    subtitle = _a.subtitle,
    style = _a.style,
    title = _a.title,
    signInButton = _a.signInButton,
    className = _a.className,
    openInNewWindow = _a.openInNewWindow;
  var analyticsStore = useStores().analyticsStore;
  var primaryButton = signInButton;
  var firstActionOnClick = (_b = action === null || action === void 0 ? void 0 : action.first) === null || _b === void 0 ? void 0 : _b.clickAction;
  var signInURL = firstActionOnClick === null || firstActionOnClick === void 0 ? void 0 : firstActionOnClick.anchorTagUrl;
  function getLayoutFlexBanner() {
    return React.createElement(React.Fragment, null, React.createElement(UitkLayoutFlexItem, null, React.createElement(BannerMedia, {
      icon: icon,
      mark: mark,
      graphic: (graphic === null || graphic === void 0 ? void 0 : graphic.__typename) === 'Illustration' ? graphic : null
    })), React.createElement(UitkLayoutFlexItem, {
      grow: 2
    }, React.createElement(UitkSpacing, {
      padding: {
        inlinestart: 'one'
      }
    }, React.createElement("div", null, React.createElement(React.Fragment, null, (title === null || title === void 0 ? void 0 : title.text) && React.createElement(UitkHeading, {
      tag: "h3",
      size: 7
    }, title.text), subtitle && React.createElement(UitkText, {
      size: 300
    }, subtitle.text)), ((action === null || action === void 0 ? void 0 : action.first) || (action === null || action === void 0 ? void 0 : action.second)) && !signInButton && React.createElement(UitkSpacing, {
      padding: {
        blockstart: 'two'
      }
    }, React.createElement(UitkList, {
      orientation: "inline",
      bullet: "no-bullet",
      spacing: false
    }, React.createElement(UitkListItem, null, (action === null || action === void 0 ? void 0 : action.first) && ActivityMessageBannerLink(action.first, analyticsStore)), React.createElement(UitkListItem, null, (action === null || action === void 0 ? void 0 : action.second) && ActivityMessageBannerLink(action.second, analyticsStore, openInNewWindow))))))));
  }
  return React.createElement(Viewport, null, React.createElement(ViewLarge, null, React.createElement(UitkCard, __assign({}, mapMessagingCardMediaProps(icon, mark), {
    padded: true,
    border: true,
    className: className,
    "data-testid": "activity-message-banner",
    style: style
  }), React.createElement(UitkLayoutFlex, {
    alignItems: "center",
    space: "two"
  }, getLayoutFlexBanner(), (primaryButton === null || primaryButton === void 0 ? void 0 : primaryButton.primary) && signInURL && React.createElement(UitkLayoutFlexItem, {
    minWidth: 130
  }, React.createElement(EGDSPrimaryButton, {
    href: signInURL
  }, primaryButton.primary))))), React.createElement(ViewSmall, null, React.createElement(UitkCard, __assign({}, mapMessagingCardMediaProps(icon, mark), {
    padded: true,
    border: true,
    className: className,
    "data-testid": "activity-message-banner",
    style: style
  }), React.createElement(UitkLayoutFlex, {
    alignItems: "center",
    space: "two"
  }, getLayoutFlexBanner()), (primaryButton === null || primaryButton === void 0 ? void 0 : primaryButton.primary) !== undefined && React.createElement(UitkLayoutFlex, {
    justifyContent: "end"
  }, React.createElement(UitkSpacing, null, React.createElement(EGDSPrimaryButton, {
    href: signInURL !== null && signInURL !== void 0 ? signInURL : undefined
  }, primaryButton.primary))))));
};